import axios, { AxiosInstance } from 'axios';

const CALENDAR_REQUEST_PREFIX = 'calendar';
const LOGOS_REQUEST_PREFIX = 'logos';

export default class CalendarService {
  api: AxiosInstance;

  token: string;

  constructor() {
    this.api = axios.create({
      baseURL: `https://api.benzinga.com/api/v2.1/`,
    });
    this.token = '449790be7e324521b2dd3b57aed1ab5d';
  }

  requestQueryParams(query: any) {
    return {
      token: this.token,
      ...query,
    };
  }

  getRetail(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/retail`, {
      params: this.requestQueryParams(query),
    });
  }

  getDividends(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/dividends`, {
      params: this.requestQueryParams(query),
    });
  }

  getConferenceCalls(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/conference-calls`, {
      params: this.requestQueryParams(query),
    });
  }

  getMA(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/ma`, {
      params: this.requestQueryParams(query),
    });
  }

  getRetailByTicker(ticker: any) {
    const query = {
      'parameters[tickers]': ticker,
    };

    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/retail`, {
      params: this.requestQueryParams(query),
    });
  }

  getLogosByTickers(tickers: any) {
    const query = {
      symbols: tickers,
    };

    return this.api.get(`https://api.benzinga.com/api/v1/${LOGOS_REQUEST_PREFIX}`, {
      params: this.requestQueryParams(query),
    });
  }

  getEarnings(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/earnings`, {
      params: this.requestQueryParams(query),
    });
  }

  getEconomics(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/economics`, {
      params: this.requestQueryParams(query),
    });
  }

  getGuidance(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/guidance`, {
      params: this.requestQueryParams(query),
    });
  }

  getIPOs(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/ipos`, {
      params: this.requestQueryParams(query),
    });
  }

  getShortInterests(query: any) {
    return this.api.get(`https://data-api.benzinga.com/rest/v1/shortinterest`, {
      params: {
        ...query,
        apikey: '2RiuR92vjytxS8r93w3c8WTpGSd3y9Gk',
        asOf: query?.dateFrom ?? '',
        symbols: query.symbols ?? '',
      },
    });
  }

  getOptionActivitySignals(query: any) {
    return this.api.get(`https://api.benzinga.com/api/v1/signal/option_activity`, {
      params: this.requestQueryParams(query),
    });
  }

  getSplits(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/splits`, {
      params: this.requestQueryParams(query),
    });
  }

  getAnalystRatings(query: any) {
    return this.api.get(`${CALENDAR_REQUEST_PREFIX}/ratings`, {
      params: {
        ...this.requestQueryParams(query),
        fields:
          'fields=id,ticker,analyst_id,ratings_accuracy.smart_score,analyst_name,action_company,action_pt,adjusted_pt_current,adjusted_pt_prior,analyst,analyst_name,currency,date,exchange,id,importance,name,notes,pt_current,pt_prior,rating_current,rating_prior,ticker,time,updated,url,url_calendar,url_news,logo,quote',
      },
    });
  }

  getFda(query: any) {
    return this.api.get('https://api.benzinga.com/api/v2.1/calendar/fda', {
      params: this.requestQueryParams(query),
    });
  }

  getInsiderTrades(query: any) {
    return this.api.post('https://www.benzinga.com/sec/insider-trades/api/insider-trades', query);
  }
}
